import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const teamMembersSlice = createSlice({
  name: "teamMember",
  initialState,
  reducers: {},
});

export const {} = teamMembersSlice.actions;
export default teamMembersSlice.reducer;
